import toUpperCase from 'src/filters/toUpperCase'
import toLowerCase from 'src/filters/toLowerCase'
import capitalize from 'src/filters/capitalize'

const GlobalFilters = {
  install (Vue) {
    Vue.filter('toUpperCase', toUpperCase)
    Vue.filter('toLowerCase', toLowerCase)
    Vue.filter('capitalize', capitalize)
  }
}

export default GlobalFilters